import {gsap} from 'gsap/all';
import React, { useRef, useEffect } from 'react'
import { textLoop } from '../../utils/gsapService';

export default function TextSlide() {

  const textTop = useRef(null);
  const textBottom = useRef(null);



  useEffect(() => { 

    const topTextItem = document.querySelectorAll(".text-slide-section .slide-top .text-item");
    const bottomTextItem = document.querySelectorAll(".text-slide-section .slide-bottom .text-item");

    const rightTextLoop = textLoop("right", topTextItem);
    const leftTextLoop = textLoop("left", bottomTextItem);

    rightTextLoop.duration(80);
    leftTextLoop.duration(80);

    return () => {  
      rightTextLoop.restart(); 
      rightTextLoop.kill(); 

      leftTextLoop.restart(); 
      leftTextLoop.kill(); 
    };
  }, []);
 
  return (
    <section className="text-slide-section title-md">  
        <div className="slide-top" ref={textTop}>
            <div className="text-item">Art & Design — Philosophy — Why Barrel Proof — Art & Design — Philosophy — Why Barrel Proof —  </div>
            <div className="text-item">Art & Design — Philosophy — Why Barrel Proof — Art & Design — Philosophy — Why Barrel Proof —  </div>
        </div>
        <div className="slide-bottom" ref={textBottom}>
            <div className="text-item">Neat or on the Rocks — Wine & Bourbon — Art & Design — Neat or on the Rocks — Wine & Bourbon — Art & Design —</div>
            <div className="text-item">Neat or on the Rocks — Wine & Bourbon — Art & Design — Neat or on the Rocks — Wine & Bourbon — Art & Design —</div>
        </div>
    </section>
  )
}
